/* tslint:disable */
/* eslint-disable */
/**
 * Workflow service API
 * Service for workflow management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RemovalResponseDto
 */
export interface RemovalResponseDto {
    /**
     * Created or processed Workflow instance Id
     * @type {string}
     * @memberof RemovalResponseDto
     */
    workflowInstanceId?: string;
    /**
     * 
     * @type {string}
     * @memberof RemovalResponseDto
     */
    requesterId?: string;
}

/**
 * Check if a given object implements the RemovalResponseDto interface.
 */
export function instanceOfRemovalResponseDto(value: object): boolean {
    return true;
}

export function RemovalResponseDtoFromJSON(json: any): RemovalResponseDto {
    return RemovalResponseDtoFromJSONTyped(json, false);
}

export function RemovalResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): RemovalResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'workflowInstanceId': json['workflowInstanceId'] == null ? undefined : json['workflowInstanceId'],
        'requesterId': json['requesterId'] == null ? undefined : json['requesterId'],
    };
}

export function RemovalResponseDtoToJSON(value?: RemovalResponseDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'workflowInstanceId': value['workflowInstanceId'],
        'requesterId': value['requesterId'],
    };
}

